import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';


@Component({
  selector: 'app-analytics-expense',
  templateUrl: './analytics-expense.component.html',
  styleUrls: ['./analytics-expense.component.scss']
})
export class AnalyticsExpenseComponent {
  companyId = this.authService.getCurrentCompanyId();
  dashboardUrl!: SafeResourceUrl;
  dashboardProducts!: SafeResourceUrl;
  dashboardWarehouse!: SafeResourceUrl;
      
  iframeError = false;
  iframeError2 = false;
  iframeError3 = false;
  constructor(
      private cdRef: ChangeDetectorRef,
      public sanitizer: DomSanitizer,
      private authService : AuthenticationService
  ) {
      
  }

  onIframeError() {
      console.error('Error al cargar el iframe');
      this.iframeError = true; // Oculta el iframe si falla
    }

  onIframeLoad(index: number) {
      console.log(`Iframe ${index} cargado.`);
  }

  ngOnInit() {
      this.companyId = this.authService.getCurrentCompanyId();
      setTimeout(() => {
          this.dashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              `https://lookerstudio.google.com/embed/reporting/a36ace1f-5c21-460b-9241-c2f7cb411d6c/page/uao9E?params=%7B"df1":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
          );
  
          this.dashboardProducts = this.sanitizer.bypassSecurityTrustResourceUrl(
              `https://lookerstudio.google.com/embed/reporting/74dd305d-0ee2-450e-88c1-d3caa3e61159/page/uao9E?params=%7B"df1":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
          );
  
          this.dashboardWarehouse = this.sanitizer.bypassSecurityTrustResourceUrl(
              `https://lookerstudio.google.com/embed/reporting/f9fc2d71-1c17-4d3e-838e-1976865a2e22/page/uao9E?params=%7B"df1":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
          );
      }, 500);
      this.cdRef.detectChanges();
  }
}
